import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Provider } from 'src/models/Provider.interface';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { BillingService } from '../services/billing.service';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css'],
  providers: [DatePipe],
})
export class BillingComponent implements OnInit {
  billingForm!: FormGroup;
  providers: Provider[] = [];
  showAdvancedOptions: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private billingService: BillingService,
    private datePipe: DatePipe,
    private router: Router,
  ) { }

  // En BillingComponent

  ngOnInit(): void {
    this.billingForm = this.fb.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required], // Asigna directamente la fecha de hoy si es necesario
      clientCode: [''], // Opcional
      cif: [''], // Opcional
    });
  }

  confirmSubmit(): void {
    if (this.billingForm.valid) {
      const { startDate, endDate, clientCode, cif } = this.billingForm.value;

      // Cambia el formato de las fechas a dd-MM-yyyy
      const formattedStartDate = this.datePipe.transform(
        startDate,
        'dd-MM-yyyy'
      );
      const formattedEndDate = this.datePipe.transform(endDate, 'dd-MM-yyyy');

      const billingData: any = {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        clientCode: clientCode ? Number(clientCode) : undefined,
        cif: cif,
      };

      this.isLoading = true;
      this.billingService.sendBillingInfoToBillers(billingData).subscribe({
        next: (response) => {
          this.isLoading = false;
          Swal.fire({
            title: '¡Éxito!',
            text: `Los datos de facturación han sido enviados. El ID de proceso es: ${response.billingProcessId}`,
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Ver proceso de facturación',
            cancelButtonText: 'Cerrar',
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['home/billing-process']);
            }
          });
        },

        error: (error) => {
          this.isLoading = false;
          Swal.fire(
            'Error',
            'Hubo un problema al enviar tus datos. Por favor, inténtalo de nuevo.',
            'error'
          );
        },
      });
    } else {
      Swal.fire(
        'Atención',
        'Completa correctamente todos los campos requeridos.',
        'info'
      );
    }
  }

  onClientCodeChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value) {
      this.billingForm.get('cif')?.disable();
    } else {
      this.billingForm.get('cif')?.enable();
    }
  }

  onCifChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value) {
      this.billingForm.get('clientCode')?.disable();
    } else {
      this.billingForm.get('clientCode')?.enable();
    }
  }
  clearFilters(): void {
    this.billingForm.reset({
      startDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd'), // O cualquier valor inicial que desees
      endDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd'), // O cualquier valor inicial que desees
      clientCode: '',
      cif: '',
    });
  }
  toggleAdvancedOptions(): void {
    this.showAdvancedOptions = !this.showAdvancedOptions;
  }
}
